
(function(){var m=document.querySelector('[data-sc="anuncio"] .wt-announcement__container'); if(!m||m.dataset.onMq) return; m.dataset.onMq='1';
  var c=m.querySelector('.wt-announcement__marquee'); if(!c) return;
  var items=Array.from(c.children); var n=Math.max(1, Math.ceil(window.innerWidth*1.2/Math.max(1,c.getBoundingClientRect().width)));
  for(var k=0;k<n;k++) items.forEach(function(i){ c.appendChild(i.cloneNode(true)); });
  var c2=c.cloneNode(true); c2.setAttribute('aria-hidden','true'); m.appendChild(c2);
  var d=(c.getBoundingClientRect().width/50)+'s'; c.style.setProperty('--on-dur',d); c2.style.setProperty('--on-dur',d); })();


(function(){var g=document.querySelector('[data-sc="menu"]'); if(!g) return;
  function abrir(e){ if(e) e.preventDefault(); g.classList.add('on-aberto'); document.documentElement.style.overflow='hidden'; }
  function fechar(){ g.classList.remove('on-aberto'); document.documentElement.style.overflow=''; }
  document.querySelectorAll('[data-on-menu]').forEach(function(t){ t.addEventListener('click', abrir); });
  g.addEventListener('click', function(e){ if(e.target.closest('[data-on-close]') || !e.target.closest('.wt-drawer__content')) fechar(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') fechar(); });
})();


(function(){document.querySelectorAll('[data-sc="rodape"] [data-on-toggle]').forEach(function(t){ t.addEventListener('click', function(){ var c=t.closest('collapsible-section')||t.parentElement; c.classList.toggle('on-aberto'); t.setAttribute('aria-expanded', c.classList.contains('on-aberto')); }); });})();
